import { render, staticRenderFns } from "./Closed.vue?vue&type=template&id=061ac8fc&scoped=true"
import script from "./Closed.vue?vue&type=script&lang=js"
export * from "./Closed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ac8fc",
  null
  
)

export default component.exports